import { Token, Hash } from 'types/entities'

import { TxStatuses, TxTypes } from 'constants/transaction'

export enum Setting {
  RPC_URL = 'RPC_URL',
  LANGUAGE = 'LANGUAGE',
  IS_SIGNED = 'IS_SIGNED',
  IS_MAX_APPROVE = 'IS_MAX_APPROVE',
  SHOW_ADDRESS_GENERATOR = 'SHOW_ADDRESS_GENERATOR',
}

export type Settings = {
  [Setting.RPC_URL]: string
  [Setting.LANGUAGE]: string
  [Setting.IS_SIGNED]: boolean
  [Setting.IS_MAX_APPROVE]: boolean
  [Setting.SHOW_ADDRESS_GENERATOR]: boolean
}

export type Transaction = {
  to: Hash
  from: Hash
  txHash: Hash
  token?: Token
  type: TxTypes
  value?: string
  error?: string
  timestamp?: string
  airdropId?: string
  status: TxStatuses
  chainId: SupportedChainId
}

// key in transaction hash
export type TransactionsHistory = Record<string, Transaction>
